import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface CheckboxControllerTargetLifecycleHooks {
  public fun buttonTargetConnected(element: HTMLElement) {
  }

  public fun buttonTargetDisconnected(element: HTMLElement) {
  }

  public fun checkboxTargetConnected(element: HTMLElement) {
  }

  public fun checkboxTargetDisconnected(element: HTMLElement) {
  }

  public fun allTargetConnected(element: HTMLElement) {
  }

  public fun allTargetDisconnected(element: HTMLElement) {
  }
}

public fun <T : HTMLElement> CheckboxController.buttonTarget(): StimulusProperty<T> =
    StimulusProperty("buttonTarget")

public fun <T : HTMLElement> CheckboxController.buttonTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("buttonTargets")

public fun <T : HTMLElement> CheckboxController.checkboxTarget(): StimulusProperty<T> =
    StimulusProperty("checkboxTarget")

public fun <T : HTMLElement> CheckboxController.checkboxTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("checkboxTargets")

public fun <T : HTMLElement> CheckboxController.allTarget(): StimulusProperty<T> =
    StimulusProperty("allTarget")

public fun <T : HTMLElement> CheckboxController.allTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("allTargets")

public fun registerCheckboxController(stimulus: Application) {
               val clazz = CheckboxController::class
               val properties = object  {
                  // Js name needed otherwise Kotlin will mangle the name
                  @JsName("targets")
                  val targets = js("""[
  "button",
  "checkbox",
  "all",
  ]""")

                  @JsName("values")
                  val values = buildValues(
                      setOf(
                          
                      ),
                      null
                  )
                  
                  
                  
                  @JsName("classes")
                  val classes = js("[]")
              }

              val factoryFunc = clazz.js.asDynamic()

              addStaticMembersTo(factoryFunc, properties)
              val controllerName = "checkbox"
              println("Registering controller checkbox")

              stimulus.register(controllerName, factoryFunc)
}
